module.exports = __webpack_public_path__ + "static/media/6 (1).7fa7fe6c.webp";